import { Button } from "../ui/button";
import { X, CheckSquare, Loader2, FileDown, FileSpreadsheet } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Sticky bottom action bar shown while one or more admin-dealer rows are
 * selected. Stacks on mobile (<640px) and stays compact on desktop.
 */
export default function BulkActionBar({ count, busy, exporting, exportingListings,
                                         onClear, onApprove, onExportZip, onExportListingsZip }) {
    const { t } = useTranslation();
    if (count === 0) return null;
    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 bg-[#111827] text-white border-t-4 border-[#FFCC00] shadow-2xl"
            data-testid="bulk-action-bar"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                    <div
                        className="w-10 h-10 sm:w-8 sm:h-8 bg-[#FFCC00] text-[#111827] rounded-sm flex items-center justify-center font-black shrink-0 font-mono-num"
                        data-testid="bulk-selected-count"
                    >
                        {count}
                    </div>
                    <div className="min-w-0">
                        <div className="text-sm font-bold uppercase tracking-wider truncate">{count} {t("admin_dealers.bulk_count_suffix")}</div>
                        <div className="text-xs text-white/60 hidden sm:block">{t("admin_dealers.bulk_hint")}</div>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-2">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClear}
                        className="rounded-sm border-white/30 text-white hover:bg-white/10 font-bold text-xs uppercase tracking-wider bg-transparent h-11 sm:h-9"
                        data-testid="bulk-clear"
                    >
                        <X className="w-3 h-3 mr-1" /> {t("admin_dealers.bulk_clear")}
                    </Button>
                    {onExportZip && (
                        <Button
                            type="button"
                            variant="outline"
                            onClick={onExportZip}
                            disabled={busy || exporting || exportingListings}
                            className="rounded-sm border-white/30 text-white hover:bg-white/10 font-bold text-xs uppercase tracking-wider bg-transparent h-11 sm:h-9"
                            data-testid="bulk-export-zip"
                        >
                            {exporting
                                ? <Loader2 className="w-4 h-4 animate-spin mr-1" />
                                : <FileDown className="w-4 h-4 mr-1" />}
                            {t("admin_dealers.bulk_export_zip")}
                        </Button>
                    )}
                    {onExportListingsZip && (
                        <Button
                            type="button"
                            variant="outline"
                            onClick={onExportListingsZip}
                            disabled={busy || exporting || exportingListings}
                            className="rounded-sm border-white/30 text-white hover:bg-white/10 font-bold text-xs uppercase tracking-wider bg-transparent h-11 sm:h-9"
                            data-testid="bulk-export-listings-zip"
                        >
                            {exportingListings
                                ? <Loader2 className="w-4 h-4 animate-spin mr-1" />
                                : <FileSpreadsheet className="w-4 h-4 mr-1" />}
                            {t("admin_dealers.bulk_export_listings_zip")}
                        </Button>
                    )}
                    <Button
                        type="button"
                        onClick={onApprove}
                        disabled={busy}
                        className="bg-[#FFCC00] hover:bg-[#E6B800] text-[#111827] rounded-sm font-bold text-xs uppercase tracking-wider h-11 sm:h-9"
                        data-testid="bulk-approve-btn"
                    >
                        {busy
                            ? <Loader2 className="w-4 h-4 animate-spin mr-1" />
                            : <CheckSquare className="w-4 h-4 mr-1" />}
                        {t("admin_dealers.bulk_approve")}
                    </Button>
                </div>
            </div>
        </div>
    );
}
